import * as React from 'react';
import { Helmet } from 'react-helmet';
import { Occupation, WithContext } from 'schema-dts';
import { HeadHelper } from '../Helpers/HeadHelper';
import { Candidate } from '../Model/Candidate';
import { UriBuilder } from '../Service/UriBuilder';
import { StaticSettings } from '../StaticSettings';
import { Type } from '../Type';
import { RequestProfileButton } from './Button/RequestProfileButton';
import { ShowIcon } from './Button/ShowIcon';
import { AdditionalInformation } from './Candidate/AdditionalInformation';
import { YearOfBirth } from './Candidate/YearOfBirth';
import { DetailProps } from './DetailProps';
import { NlToList } from './NlToList';
import { Sharing } from './Sharing';
import { Sidebar } from './Sidebar';
import { Trans } from './Trans';

export class CandidateDetail extends React.Component<DetailProps<Candidate>> {
    public render() {
        const props = this.props;
        const openModel = props.model;
        const filteredModels = props.filteredModels;

        return <div className="job-center-detail-viewport row">
            {this.renderHead(openModel)}
            {this.renderInner(openModel)}
            <Sidebar type={Type.Candidate} openModel={openModel} models={filteredModels} multiSelect={false}/>
        </div>;
    }

    public componentDidMount() {
        HeadHelper.removeDefaultCanonical();
    }

    private renderInner(candidate: Candidate) {
        return <section className="job-center-detail-inner col-sm-7">
            <h2>{candidate.title}</h2>

            <div className="reference-id">
                <h3><Trans>Referenznummer</Trans></h3>
                <p>REF {candidate.referenceId}</p>
            </div>

            <div className="education">
                <h3><Trans>Aus-/Weiterbildung</Trans></h3>
                <NlToList>{candidate.education}</NlToList>
            </div>

            <div className="skills">
                <h3><Trans>Sprachen</Trans></h3>
                <NlToList>{candidate.languages}</NlToList>
            </div>

            <YearOfBirth candidate={candidate}/>

            <div className="career-Aspiration">
                <h3><Trans>Berufswunsch</Trans></h3>
                <NlToList>{candidate.careerAspiration}</NlToList>
            </div>

            <AdditionalInformation candidate={candidate}/>

            <div className="industry">
                <h3><Trans>Branche</Trans></h3>
                <p>{candidate.industry?.name}</p>
            </div>

            <div className="button-group">
                <RequestProfileButton candidate={candidate} showIcon={ShowIcon.Left}/>
            </div>

            <hr/>

            <Sharing model={candidate}/>
        </section>;
    }

    private renderHead(candidate: Candidate) {
        const uriBuilder = new UriBuilder();
        const sharingUri = uriBuilder.sharingUriForModel(candidate);
        const title = this.context.i18n.translate('Kandidat %s', [candidate.title]);

        return <Helmet>
            <title>{StaticSettings.client.name}: {title}</title>
            <link rel="canonical" href={sharingUri}/>
            <script className='structured-data-list' type="application/ld+json">{
                JSON.stringify(this.getStructuredJSON(candidate))
            }</script>
        </Helmet>;
    }

    private getStructuredJSON(candidate: Candidate): WithContext<Occupation> {
        return {
            '@context': 'https://schema.org',
            '@type': 'Occupation',
            name: candidate.title,
            identifier: candidate.referenceId,
            educationRequirements: candidate.education,
            qualifications: candidate.languages,
        };
    }
}
